import { HOST } from "../config";
import axios from "axios";
import qs from "qs";

// const token = sessionStorage.getItem('access_token');
const token = localStorage.getItem("access_token");
const headers = {
  Authorization: `Bearer ${token}`,
};

// 추천기업 리스트 가져오기
export async function getRecommendCorpAPI(size, type, order = "desc") {
  try {
    const res = await axios.get(
      `${HOST}/stocks/list?&size=${size}&orderstandard=${type}&ordertype=${order}`
    );
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return null;
  }
}

//마이기업 리스트 가져오기
export async function getMycorpAPI() {
  if (!!token) {
    try {
      const res = await axios.get(`${HOST}/user/interest`, {
        headers: headers,
      });
      if (res.data.resultcode === "200") {
        return res.data.data;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  }
}

//마이기업 구독 확인 (IF_MP_00021)
export async function checkMycorpAPI(stockcode) {
  if (!!token) {
    try {
      const res = await axios.get(
        `${HOST}/user/interest?stockcodes=${stockcode}`,
        { headers: headers }
      );
      return res.data.resultcode === "200";
    } catch (err) {
      return null;
    }
  }
}

//마이기업 구독 추가
export async function addMycorpAPI(stockcode) {
  if (!!token) {
    try {
      const res = await axios.put(
        `${HOST}/user/interest/${stockcode}/KR`,
        {},
        { headers: headers }
      );
      if (res.data.resultcode === "200") {
        return res.data.data;
      } else return null;
    } catch (err) {
      return null;
    }
  }
}

//마이기업 구독취소
export async function delMycorpAPI(stockcode) {
  if (!!token) {
    try {
      const res = await axios.delete(`${HOST}/user/interest/${stockcode}/KR`, {
        headers: headers,
      });
      return res.data.data;
    } catch (err) {
      return null;
    }
  }
}

export async function getNoneNewsMsg(stockname, stockcode) {
  try {
    const params = {
      stockcode: stockcode,
      size: 1,
    };
    const res = await axios.get(`${HOST}/news/realtime`, { params: params });
    if (res.data.resultcode === "200") {
      const news = res.data.data[0];
      return `오늘 ${stockname} 뉴스가 보도되지 않았습니다.\n 마지막 뉴스는 ${news.registdate.slice(
        0,
        10
      )} 보도되었습니다.\n\n ${stockname}가 속한 ${
        news.FICS_sub
      } 산업의 추천 뉴스는 11개가 있습니다.\n ${
        news.themename
      } 테마의 추천 뉴스 15개가 있습니다.`;
    } else return "";
  } catch (err) {
    return null;
  }
}

//북마크 리스트 체크
export async function checkScrapAPI(newsid) {
  if (!!token) {
    try {
      const res = await axios.get(`${HOST}/scrape/news?newsid=${newsid}`, {
        headers: headers,
      });
      if (res.data.resultcode === "200") {
        return res.data.data;
      }
      return [];
    } catch (err) {
      return null;
    }
  }
}

//공시 뉴스 스크랩 추가
export async function addScrapAPI(newsid, type) {
  const params = { newsid: newsid, newstype: type };
  if (!!token) {
    try {
      const res = await axios.post(
        `${HOST}/scrape/news`,
        qs.stringify(params),
        { headers: headers }
      );
      return res.data;
    } catch (err) {
      return null;
    }
  }
}

//뉴스 스크랩 삭제
export async function delScrapAPI(newsid) {
  if (!!token) {
    try {
      const res = await axios.delete(`${HOST}/scrape/news?newsid=${newsid}`, {
        headers: headers,
      });
      return res.data.resultcode === "200";
    } catch (err) {
      return null;
    }
  }
}

//마이기업 - 전체 메인관련 정보
export async function getMyDataAPI(category, type, order, limit = 3) {
  try {
    const res = await axios.get(
      `${HOST}/home/my/${category}?type=${type}&orderstandard=${order}&newslimit=${limit}`,
      { headers: headers }
    );
    return res.data.data;
  } catch (err) {
    window.location.replace("/error");
    return null;
  }
}

/******************스크랩*******************/

//스크랩 카테고리 목록 조회 (IF_MP_00015)
export async function getScrapCategory(id = null, order = "asc") {
  try {
    const res = await axios.get(`${HOST}/scrape/category`, {
      headers: headers,
    });
    if (res.data.resultcode === "200") {
      return res.data.data;
    } else return [];
  } catch (err) {
    return [];
  }
}

//스크랩 카테고리 이름 등록 (IF_MP_00017)
export async function enterCategoryAPI(name) {
  try {
    const params = { categoryname: name };
    const res = await axios.post(
      `${HOST}/scrape/category`,
      qs.stringify(params),
      { headers: headers }
    );
    return res.data.resultcode === "200";
  } catch (err) {
    return null;
  }
}

//스크랩 카테고리 삭제 (IF_MP_00016)
export async function deleteCategory(id) {
  try {
    const res = await axios.delete(`${HOST}/scrape/category/${id}`, {
      headers: headers,
    });
    return res.data.resultcode === "200";
  } catch (err) {
    return null;
  }
}

//스크랩 카테고리 이름 수정 (IF_MP_00017)
export async function editCategory(id, newName) {
  try {
    const params = { categoryname: newName };
    const res = await axios.post(
      `${HOST}/scrape/category/${id}`,
      qs.stringify(params),
      { headers: headers }
    );
    return res.data.resultcode === "200";
  } catch (err) {
    return null;
  }
}

//뉴스 특정 카테고리로 분류
export async function categorizeNewsAPI(scrapeIdx, categoryId = "0") {
  try {
    const params = { categoryid: categoryId };
    const res = await axios.post(
      `${HOST}/scrape/news/${scrapeIdx}`,
      qs.stringify(params),
      { headers: headers }
    );
    return res.data.data;
  } catch (err) {
    return null;
  }
}

//카테고리로 할당된 뉴스 카테고리 제거
export async function resetCategoryAPI(idx) {
  try {
    const params = { categoryid: "0" };
    const res = await axios.post(
      `${HOST}/scrape/news/${idx}`,
      qs.stringify(params),
      { headers: headers }
    );
    if (res.data.resultcode === "200") {
      return true;
    } else return false;
  } catch (err) {
    return null;
  }
}

//스크랩한 뉴스 목록 조회(IM_MP_00011)
export async function getScrapedNewsAPI() {
  if (!!token) {
    try {
      const res = await axios.get(`${HOST}/scrape/news`, { headers: headers });
      if (res.data.resultcode === "200") {
        return res.data.data;
      } else return null;
    } catch (err) {
      return null;
    }
  } else {
  }
}

//스크랩한 뉴스 목록에서 제거 (IF_MP_00012)
export async function deleteScrapNewsAPI(idx) {
  try {
    const res = await axios.delete(`${HOST}/scrape/news/${idx}`, {
      headers: headers,
    });
    return res.data.resultcode === "200";
  } catch (err) {
    return null;
  }
}

//스크랩 뉴스 공유
export async function shareNewsAPI(data) {
  try {
    const res = await axios.post(`${HOST}/scrape/send`, qs.stringify(data), {
      headers: headers,
    });
    return res.data.resultcode === "200";
  } catch (err) {
    return null;
  }
}
